import {
    SET_LOCATION_COMMUNITIES,
    SET_LOCATION_PROVINCES,
    SET_LOCATION_TOWNS,
    SET_LOCATION_POSTAL_CODES
} from '../mutation-types';
import {
    getCommunities,
    getProvinces,
    getTowns,
    getPostalCodes
} from '@/api/location-api';

const initialState = {
    communities: [],
    provinces: [],
    towns: [],
    postalCodes: []
};

const mutations = {
    [SET_LOCATION_COMMUNITIES](state, communities) {
        state.communities = communities;
    },
    [SET_LOCATION_PROVINCES](state, provinces) {
        state.provinces = provinces;
    },
    [SET_LOCATION_TOWNS](state, towns) {
        state.towns = towns;
    },
    [SET_LOCATION_POSTAL_CODES](state, postalCodes) {
        state.postalCodes = postalCodes;
    }
};

const actions = {
    loadCommunities({ commit }) {
        getCommunities().then(communities => {
            commit(SET_LOCATION_COMMUNITIES, communities)
        });
    },
    loadProvinces({ commit }, communityId) {
        getProvinces(communityId).then(provinces => {
            commit(SET_LOCATION_PROVINCES, provinces)
        });
    },
    loadTowns({ commit }, provinceId) {
        getTowns(provinceId).then(towns => {
            commit(SET_LOCATION_TOWNS, towns)
        });
    },
    loadPostalCodes({ commit }, townId) {
        getPostalCodes(townId).then(postalCodes => {
            commit(SET_LOCATION_POSTAL_CODES, postalCodes)
        });
    }
};

export default {
    state: initialState,
    mutations,
    actions
}